// extracted by mini-css-extract-plugin
module.exports = {"mypage_subsc_address":"address_mypage_subsc_address__3XFN5"};